import { useImmer } from 'use-immer';
import { freeze } from '@reduxjs/toolkit';
import { Range } from '@tiptap/core';

interface ISuggestionState {
  type: 'mention' | 'emoji' | null;
  term: string;
  range: Range | null;
}

const defaultSuggestionState = freeze<ISuggestionState>(
  {
    type: null,
    term: '',
    range: null,
  },
  true,
);

const useSuggestionState = () => {
  const [suggestionState, setSuggestionState] = useImmer<ISuggestionState>(
    defaultSuggestionState,
  );

  const resetSuggestionState = () => {
    setSuggestionState((draft) => {
      if (draft.type !== null) {
        return defaultSuggestionState;
      }
    });
  };

  return {
    suggestionState,
    setSuggestionState,
    resetSuggestionState,
  };
};

export default useSuggestionState;
